
import { doPost } from './Api';

export default class Login {
  static async responseAuth(user,password) {
    const response = await doPost(`${process.env.REACT_APP_BASE_URL}/Auth`,{login:user, password});
    if(response.data.success){
      return response.data;
    }else{
      throw 'invalid credentials';
    }
  }
}
